export default "__VITE_ASSET__CkJFTrpf__"